export interface ParsedJwtToken {
    user: string;
    licenseId: number;
    license: string;
    issuedAt: Date;
    expireDate: Date;
    expired: boolean;
}

/**
 * Parse JWT Token and extract Parameters.
 */
export function parseToken(token: string): ParsedJwtToken | null {
    if (!token) return null;
    try {
        const parsedSegments = token.split(".");
        if (!Array.isArray(parsedSegments) || parsedSegments.length !== 3) {
            console.error("Invalid JWT token format:", token);
            return null;
        }
        // Index 0 = algorithm, Index 1 = parameters, Index 2 = Signature
        const parameters = JSON.parse(atob(parsedSegments[1]));
        const expireDate = new Date(parameters["exp"] * 1000);
        return {
            user: parameters["sub"] as string,
            licenseId: parameters["lid"] as number,
            license: parameters["lic"] as string,
            issuedAt: new Date(parameters["iat"] * 1000),
            expireDate: expireDate,
            expired: expireDate.valueOf() < Date.now(),
        };
    } catch (e) {
        console.error("Error parsing JWT token", e);
        return null;
    }
}
